<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-file-document-outline</v-icon> Avaliações
    </v-col>
    <template v-if="tests && tests.length">
      <v-col cols="12" md="4" v-for="test in tests" :key="`test-${test.id}`">
        <v-card outlined flat class="fill-height">
          <v-card-subtitle class="font-weight-black black--text pb-0">
            <v-icon color="secondary" left>mdi-file-document-outline</v-icon> {{ test.name }}
          </v-card-subtitle>
          <template v-if="test.last_step">
            <v-card-subtitle>
              <span class="d-block font-weight-black">{{ test.last_step.name }}</span>
            </v-card-subtitle>
            <v-card-text class="py-0">
              Intervalo para início da avaliação:
              <span class="d-block font-weight-black">De: {{ dateFormat(test.last_step.response_interval_init) }}</span>
              <span class="d-block font-weight-black">Até: {{ dateFormat(test.last_step.response_interval_end) }}</span>
            </v-card-text>
            <v-card-text class="pb-0">
              Tempo para realização da avaliação:
              <span class="d-block font-weight-black">{{ timeFormat(test.last_step.deadline) }}</span>
            </v-card-text>
            <v-card-text class="pb-0">
              Status da avaliação:
              <span class="d-block font-weight-black" v-if="['NI', ''].includes(test.last_step.status)">Não Inicializado</span>
              <span class="d-block font-weight-black" v-else-if="test.last_step.status === 'I'">Inicializado</span>
              <span class="d-block font-weight-black" v-else-if="test.last_step.status === 'F'">Finalizado</span>
              <span class="d-block font-weight-black" v-else-if="test.last_step.status === 'FE'">Finalizado Pelo Sistema</span>
            </v-card-text>
            <v-card-text v-if="test.last_step.initialized_at">
              Inicializado em:
              <span class="d-block font-weight-black">{{ dateFormat(test.last_step.initialized_at) }}</span>
            </v-card-text>
            <v-card-actions>
              <v-btn block depressed :to="{ name: 'ambienteAluno.matricula.avaliacao', params: { stepId: test.last_step.id, matriculaId: matriculaId, chamadaId: test.last_step.id } }">
                <span v-if="['NI', ''].includes(test.last_step.status)">Realizar Avaliação</span>
                <span v-else-if="test.last_step.status === 'I'">Retornar à Avaliação</span>
                <span v-else-if="['F', 'FE'].includes(test.last_step.status)">Conferir Avaliação</span>
              </v-btn>
            </v-card-actions>
          </template>
          <template v-else>
            <v-card-subtitle>
              Não há chamadas para essa avaliação
            </v-card-subtitle>
          </template>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      Não há provas disponíveis
    </template>
  </v-row>
</template>

<script>
import { Course } from '@/services/resources'

const moment = require('moment')
moment.locale('pt-BR')

export default {
  props: [
    'matriculaId',
    'groupId'
  ],
  data () {
    return {
      tests: []
    }
  },
  mounted () {
    this.loadSteps()
  },
  methods: {
    loadSteps () {
      Course.getEnrollmentSteps(this.groupId, this.matriculaId)
        .then((response) => {
          this.tests = response.body
        }).catch((error) => {
          if (typeof error.body.message !== 'undefined') {
            this.$toasted.global.error({ message: error.body.message })
          } else {
            this.$toasted.global.error({ message: error.statusText })
          }
        })
    },
    dateFormat (date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
    timeFormat (time) {
      var hours = (time / 60)
      var rhours = Math.floor(hours)
      var minutes = (hours - rhours) * 60
      var rminutes = Math.round(minutes)
      return rhours + ' hora(s) e ' + rminutes + ' minuto(s)'
    }
  }
}
</script>
